import projectService from "@/service/project-service"

function ensureOfferStructure(offers = {}, offerId) {
  const offer = offers[offerId] || {}
  offer.id = offerId
  offer.conf = offer.conf || {}
  offer.conf.screens = offer.conf.screens || {}
  offer.data = offer.data || {}
  offer.data.mealIds = offer.data.mealIds || {}
  return offer
}

export default {
  offerRef(projectId, offerId) {
    return this.offersRef(projectId).child(offerId)
  },

  offersRef(projectId) {
    return projectService.projectDataRef(projectId).child("offers")
  },

  offerConfRef(projectId, offerId) {
    return this.offerRef(projectId, offerId).child("conf")
  },

  offerConfScreensRef(projectId, offerId) {
    return this.offerConfRef(projectId, offerId).child("screens")
  },

  offerMealIdsRef(projectId, offerId) {
    return this.offerRef(projectId, offerId)
      .child("data")
      .child("mealIds")
  },

  offerMealIdRef(projectId, mealId, offerId) {
    return this.offerMealIdsRef(projectId, offerId).child(mealId)
  },

  saveMealIdsToOffer(projectId, offerMealIds, offerId) {
    return this.offerMealIdsRef(projectId, offerId).set(offerMealIds)
  },

  onOffersChanged(projectId, callback, errorCallback) {
    this.offersRef(projectId).on(
      "value",
      snapshot => {
        const offers = snapshot.val() || {}
        Object.keys(offers).forEach(offerId => {
          offers[offerId] = ensureOfferStructure(offers, offerId)
        })
        callback(offers)
      },
      errorCallback
    )
  },

  offOffersChanged(projectId) {
    this.offersRef(projectId).off()
  },

  generateOfferId(projectId) {
    return this.offersRef(projectId).push().key
  },

  saveConfToOffer(projectId, offerId, conf) {
    return this.offerConfRef(projectId, offerId).set(conf)
  },

  removeOffer(projectId, offerId) {
    return this.offerRef(projectId, offerId).remove()
  },

  removeScreenFromOfferConf(projectId, offerIds = [], screenId) {
    return Promise.all(
      offerIds.map(offerId =>
        this.offerConfScreensRef(projectId, offerId)
          .child(screenId)
          .remove()
      )
    )
  },

  sortOfferMealsByOrder(offerMealIds, meals) {
    if (meals == null || offerMealIds == null) {
      return []
    }
    return Object.entries(offerMealIds)
      .map(([mealId, order]) => [meals[mealId], order])
      .filter(([meal]) => !!meal)
      .map(([meal, order]) => ({
        ...meal,
        order
      }))
      .sort((a, b) => a.order - b.order)
  }
}
